export { default } from "./useLazyStudentQuizGet";
